import { render, staticRenderFns } from "./PaymentTran.vue?vue&type=template&id=32967b16&scoped=true&"
import script from "./PaymentTran.vue?vue&type=script&lang=js&"
export * from "./PaymentTran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32967b16",
  null
  
)

export default component.exports